export function getCSPNonce(root: ParentNode = document): string {
    const nonceElement = root.querySelector<HTMLElement>('[nonce]');
    return nonceElement?.nonce || nonceElement?.getAttribute('nonce') || '';
}
